import { createRouter, RouterProvider } from '@/libs/router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/features/auth/wiring'
import { routeTree } from './routeTree.gen'

import './styles/globals.css'
import './styles/tailwind.css'

const router = createRouter({ routeTree })

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Root element not found')

createRoot(rootElement).render(
	<StrictMode>
		<RouterProvider router={router} />
	</StrictMode>,
)
